<div class="nav-tab">
  <a mat-button class="tab-label" [matMenuTriggerFor]="languageMenu">
    <mat-icon>language</mat-icon>
  </a>
</div>
<mat-menu #languageMenu="matMenu" yPosition="below" [overlapTrigger]="false" class="language-selector__menu">
  @for (option of languageOptions; track option) {
    <button mat-menu-item (click)="changeLanguage(option.code)">
      <span class="language-selector__label">
        @if (option.flag) {
          <img class="language-selector__flag" [src]="option.flag" />
        }
        {{ option.label }}
      </span>
    </button>
  }
</mat-menu>
